<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="hotelCheapestRateObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>
            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">{{ title }}</p>
                    <p>Trigger for any room rate when the total cost exceeds the hotel's lowest rate by <span
                            class="rule-config-variable" @click="isEdit = !isEdit">
                            <span v-if="hotelCheapestRateObj.value.unit === 'dollars'">
                                {{ currencySymbol }}
                            </span>
                            {{ hotelCheapestRateObj.value.cost }}
                            <span v-if="hotelCheapestRateObj.value.unit === 'percent'">%</span>
                            <b-icon icon="pencil" size="is-small"></b-icon>
                        </span></p>
                </div>
                <div class="allbtns">

                    <b-switch :rounded="true" :value="hotelCheapestRateObj.isActive"
                        v-model="hotelCheapestRateObj.isActive" @input="hotelCheapestRate" :left-label="true">{{
                            hotelCheapestRateObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>

            </div>
        </div>
        <div v-if="isEdit" class="edittravelpolicy editTravel2">
            <HotelCheapestRate :rateOptions="propsData" @hotelCheapestRate="getValue" />
            <b-button @click="saveCall">SAVE</b-button>
        </div>
        <StandardRuleActions v-if="hotelCheapestRateObj.isActive && !isEdit" :ruleObj="hotelCheapestRateObj" :title="title"
        @save="updateActions" />
    </div>
</template>
<script>
import HotelCheapestRate from "../CommonRules/HotelCheapestRate.vue";
import StandardRuleActions from "../StandardRuleActions.vue";
export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: {
        HotelCheapestRate,
        StandardRuleActions
    },
    data() {
        return {
            propsData: {
                amountVal: 5,
                amountType: 'percent'
            },
            hotelCheapestRateObj: this.value ? this.value
                : {
                    name: 'hotelCheapestRate',
                    isActive: false,
                    message: 'Trigger when room rate is greater the cheapest room rate by a certain amount.',
                    type: 'hotel',
                    value: {
                        cost: 5,
                        unit: 'percent'
                    }
                },
            isEdit: false,
            emitedValue: null,
            title: "Cost Compared to Hotel's Lowest Rate"

        }

    },
    methods: {
        hotelCheapestRate(){
            if (!this.hotelCheapestRateObj.isActive) {
                // Clear the custom action parameters when deactivating
                this.clearActionParams();
            } else {
                // Rebuild message when activating
                this.buildMessage();
            }

            this.emitRuleObj();
        },
        getValue(val) {
            this.emitedValue = val;
        },
        saveCall() {
            this.isEdit = false;
            if (this.emitedValue) {
                this.hotelCheapestRateObj.value = this.emitedValue;
                this.buildMessage();
            }
        },
        buildMessage() {
            let _cost = this.hotelCheapestRateObj.value.cost
            let _unit = this.hotelCheapestRateObj.value.unit

            let costDisplay;
            if (_unit === 'dollars') {
                // For dollars, use formatPrice and omit unit from message
                costDisplay = this.currencySymbol + _cost;
            } else {
                // For other units (like percent), include unit after cost
                costDisplay = _cost + _unit;
            }

            var string = "Trigger when room rate is more than " + costDisplay + " compared with the benchmarked cheapest rate.";
            this.hotelCheapestRateObj.message = string;

        },
        emitRuleObj() {

            this.$emit("hotelCheapestRate", this.hotelCheapestRateObj);
        },
        clearActionParams() {
            // Reset to default actions when rule is not active ()
            this.hotelCheapestRateObj.useCustomActions = false;
            delete this.hotelCheapestRateObj.visibility;
            delete this.hotelCheapestRateObj.approvalLevel;
            delete this.hotelCheapestRateObj.notifications;
        },
        updateActions(updatedRule) {
            // Merge the updated properties into hotelCheapestRateObj
            this.hotelCheapestRateObj = { ...this.hotelCheapestRateObj, ...updatedRule };

            // If useCustomActions is false, delete the associated properties
            if (!updatedRule.useCustomActions) {
                this.clearActionParams();
            }

            this.buildMessage();

            this.emitRuleObj();
        },
    },
    mounted() {
        this.emitRuleObj();
    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                if (this.value) {
                    const hotelProps = this.value;
                    this.hotelCheapestRateObj = hotelProps
                    this.propsData.amountVal = hotelProps.value.cost;
                    this.propsData.amountType = hotelProps.value.unit;
                }
                this.hotelCheapestRateObj.type = "hotel";

                this.buildMessage();
                this.emitRuleObj();
            },
            deep: true,
        },
    },
    computed: {
        defaultCurrency() {
            return this.$store.getters['travellersAndTrips/getUserCurrencyInfo'];
        },
        currencyName(){
            return this.defaultCurrency.name;
        },
        currencyCode(){
            return this.defaultCurrency.code;
        },
        currencySymbol(){
            return this.defaultCurrency.symbol;
        }
    }
}
</script>
